// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refApplicationPlatformService = {
    getByAccount,
    getById,
    add,
    update,
    deleteRefApplicationPlatform
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refApplicationPlatforms/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refApplicationPlatforms/${id}`).then(handleResponse);
}

function add(refApplicationPlatform) {
    return axios.post('/refApplicationPlatforms', refApplicationPlatform).then(handleResponse);
}

function update(refApplicationPlatform) {
    return axios.put(`/refApplicationPlatforms/${refApplicationPlatform.refApplicationPlatformId}`, refApplicationPlatform).then(handleResponse);
}

function deleteRefApplicationPlatform(refApplicationPlatform) {
    return axios.delete(`/refApplicationPlatforms/${refApplicationPlatform.refApplicationPlatformId}`).then(handleResponse);
}
